import { render, staticRenderFns } from "./TransferPricing.vue?vue&type=template&id=5039aa7e&scoped=true"
import script from "./TransferPricing.vue?vue&type=script&lang=js"
export * from "./TransferPricing.vue?vue&type=script&lang=js"
import style0 from "./TransferPricing.vue?vue&type=style&index=0&id=5039aa7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039aa7e",
  null
  
)

export default component.exports